if (window.__themeQuickViewBound) {
  // Already attached on this page.
} else {
  window.__themeQuickViewBound = true;

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-quick-view-open]');
    if (openButton) {
      const root = openButton.closest('[data-quick-view-root]');
      const dialog = root?.querySelector('dialog');
      if (dialog?.showModal) dialog.showModal();
      return;
    }

    const closeButton = event.target.closest('[data-quick-view-close]');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
    }
  });
}
